import { tokens } from "shared/components/Spor";
import size from "shared/theme/size";
import { hideScrollbar } from "shared/utils/hideScrollbar";
import styled, { css } from "styled-components";
// Some grids have tables that fill the entire body
export const SharedGridStyleNoPadding = css`
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-radius: 6px;
`;
export const SharedGridPadding = tokens.default.size.spacing[2];
export const SharedGridStyle = css`
  ${SharedGridStyleNoPadding}
  padding: ${SharedGridPadding};
`;

// These two are fit for the new color schema (Base/Main/Secondary/Tertiary)
const SharedGridStyleBaseColorNoPadding = css`
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-radius: 6px;
`;
export const SharedGridStyleBaseColor = css`
  ${SharedGridStyleBaseColorNoPadding}
  padding: ${SharedGridPadding};
`;

export const SharedContentGridLayout = css`
  display: grid;
  grid-gap: 9px;
  color: ${({ theme }) => theme.colorTextMain};
  height: 100%;
  border-radius: 6px;
  background-color: transparent;
`;

export const LandingpageContentGrid = styled.div`
  ${SharedContentGridLayout};
  overflow: hidden;
  grid-template-columns: 6fr 4fr;
  grid-template-rows: 7fr 3fr;
  grid-template-areas:
    "content-middle content-sidebar"
    "content-bottom content-bottom";

  @media (max-width: ${size.breakpoints.xxl}px) {
    grid-column: 1/3;
  }
`;

export const Sidebar = styled.div`
  ${SharedGridStyle};
  grid-area: content-sidebar;
  overflow: hidden;
`;

export const Bottom = styled.div`
  grid-area: content-bottom;
  overflow: scroll;
  padding-bottom: 0px;
  padding-top: 0px;

  ${hideScrollbar};
`;
